<template>
	
</template>
<script>
export default {
    data() {
        return {
            path: '',
            params: '',
    
        };
    },
    
    mounted() {
        this.path = this.$route.path || ''
        this.params = this.$route.query.url || ''
        // this.params = 'https://www.baidu.com/'
        window.location.href = this.params;
    },

}
</script>